import richTextFragment from '@components/renderers/rich-text.fragment'
import { marketingFormEmbedFragment } from '@components/marketing-form-embed/marketing-form-embed.fragment'
import { testimonialV2Fragment } from '@components/testimonialv2/testimonialv2.fragment'

const universityProgramFragment = `
  metaDataField
  metaImage {
    url
  }
  metaDescription
  heroImage {
    url
    description
  }
  heroImageMobile {
    url
    description
  }
  headline
  subtitle
  breadcrumbsCollection(limit: 5) {
    items {
      buttonLabel
      buttonLink
    }
  }
  ctaHeadline
  ctaButtonOne
  ctaButtonTwo
  ctaDescription
  ctaLinkText
  ctaLink
  photoSpotlight {
    headline
    overlineText
    description {
      ${richTextFragment}
    }
    ctaText
    link
    videoImage {
      url
      description
    }
    video {
      url
      description
    }
    videoEmbedId
  }
  careerSpecialistSection {
    heading
    supportiveCopy
    longSupportiveCopy
    buttonLabel
    buttonLink
    cardImage {
      description
      contentType
      url
      width
      height
    }
    backgroundImage {
      description
      contentType
      url
      width
      height
    }
    cardHeading
    cardSupportiveCopy
  }
  schoolsHeadline
  schoolsSubtitle
  schoolCategories
  schoolsCollection(limit: 30) {
    items {
      series
      headline
      summary
      ctaText
      externalLink
      secondaryCtaText
      image {
        url
        description
      }
    }
  }
  listCardAccordionSection {
    accordionCollection(limit: 1) {
      items {
        accordionDetailHeading
        accordionDetailBlurb
        accordionDetailList
        backgroundImage {
          description
          contentType
          url
          width
          height
        }
      }
    }
  }
  testimonialsSection {
    ${testimonialV2Fragment}
  }
  marketingEmailForm {
    ${marketingFormEmbedFragment}
  }
  timelineStepsCollection(limit: 5) {
    items {
      title
      eventYear
      logo {
        url
        description
      }
      eventHeadline
      eventRichText {
        ${richTextFragment}
      }
      relevantStoriesCtaText
      relevantStoriesCtaLink
    }
  }
  timelineHeader
  timelineSubtitle
  timelineBackgroundImage {
    url
    description
  }
  timelineCtaText
  timelineCtaLink
`

export default universityProgramFragment
